var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "composer-root",
      class: { "focus-filter-exclusion": _vm.filterExclusionFocusMode },
      on: {
        dragover: function($event) {
          $event.preventDefault()
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.onToolboxDrop($event)
        }
      }
    },
    [
      _c("canvas-area-zoom-controls", {
        staticClass: "zoom-controls composer-component",
        on: {
          "zoom-in": function($event) {
            return _vm.$refs.zoom.zoomIn()
          },
          "zoom-out": function($event) {
            return _vm.$refs.zoom.zoomOut()
          }
        }
      }),
      _vm._v(" "),
      _c("horizontal-scroll", {
        staticClass: "horizontal-scroll composer-component",
        attrs: {
          "min-left": _vm.boundaryPositions.x.min,
          "max-left": _vm.boundaryPositions.x.max,
          position: _vm.panX
        },
        on: {
          "update:position": function($event) {
            return _vm.panToX($event)
          }
        },
        nativeOn: {
          click: function($event) {
            $event.stopPropagation()
          }
        }
      }),
      _vm._v(" "),
      _c("vertical-scroll", {
        staticClass: "vertical-scroll composer-component",
        attrs: {
          "min-top": _vm.boundaryPositions.y.min,
          "max-top": _vm.boundaryPositions.y.max,
          position: _vm.panY
        },
        on: {
          "update:position": function($event) {
            return _vm.panToY($event)
          }
        },
        nativeOn: {
          click: function($event) {
            $event.stopPropagation()
          }
        }
      }),
      _vm._v(" "),
      _c("drag-and-drop-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var jsPlumbInstance = ref.jsPlumbInstance
              return [
                _c(
                  "canvas-area-zoom",
                  {
                    ref: "zoom",
                    attrs: {
                      "composer-component-class": "composer-component",
                      "use-parent-element-as-proxy": ""
                    },
                    on: {
                      "scale-changed": function($event) {
                        return _vm.zoomChanged(jsPlumbInstance, $event)
                      },
                      "pan-changed": _vm.panChanged
                    }
                  },
                  [
                    _c(
                      "div",
                      { ref: "compose-area", staticClass: "compose-area" },
                      [
                        _vm._l(_vm.journeyBricks, function(ref) {
                          var brick = ref.brick
                          var connectedIncomingConnections =
                            ref.connectedIncomingConnections
                          var connectedOutgoingConnections =
                            ref.connectedOutgoingConnections
                          var brickComponent = ref.brickComponent
                          var isActive = ref.isActive
                          var isHighlighted = ref.isHighlighted
                          return _c(
                            "drag-and-drop-draggable",
                            {
                              key: brick.id,
                              attrs: { "js-plumb-instance": jsPlumbInstance },
                              on: {
                                start: function($event) {
                                  return _vm.componentMoveStarted(
                                    $event.el,
                                    brick.id
                                  )
                                },
                                stop: function($event) {
                                  return _vm.brickMoveStopped(
                                    $event.el,
                                    $event.finalPos
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "brick-square-endpoints",
                                {
                                  attrs: {
                                    "js-plumb-instance": jsPlumbInstance,
                                    "brick-id": brick.id,
                                    "incoming-connections":
                                      brick.incomingConnections,
                                    "outgoing-connections":
                                      brick.outgoingConnections
                                  },
                                  on: {
                                    "connection-created": function($event) {
                                      return _vm.$emit(
                                        "connection-created",
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(brickComponent, {
                                    tag: "component",
                                    staticClass: "composer-component",
                                    attrs: {
                                      "is-active": isActive,
                                      type: brick.type,
                                      config: brick.config,
                                      x: brick.x,
                                      y: brick.y,
                                      brick: brick,
                                      "incoming-connections-info": connectedIncomingConnections,
                                      "outgoing-connections-info": connectedOutgoingConnections,
                                      "is-highlighted": isHighlighted
                                    },
                                    on: {
                                      "add-connection": function($event) {
                                        return _vm.$emit(
                                          "add-connection",
                                          brick
                                        )
                                      },
                                      "delete-brick": function($event) {
                                        return _vm.$emit("delete", {
                                          brick: brick,
                                          requiresPrompt: $event
                                        })
                                      },
                                      "settings-changed": function($event) {
                                        _vm.$emit(
                                          "settings-changed",
                                          Object.assign(
                                            { id: brick.id },
                                            $event
                                          )
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.journeyBrickConnections, function(ref) {
                          var connection = ref.connection
                          var isActive = ref.isActive
                          return _c(
                            "brick-connection",
                            {
                              key: connection.id,
                              attrs: {
                                connection: connection,
                                "js-plumb-instance": jsPlumbInstance,
                                "is-active": isActive
                              }
                            },
                            [
                              _c(
                                "drag-and-drop-draggable",
                                {
                                  attrs: {
                                    "js-plumb-instance": jsPlumbInstance
                                  },
                                  on: {
                                    start: function($event) {
                                      return _vm.componentMoveStarted(
                                        $event.el,
                                        connection.id
                                      )
                                    },
                                    stop: function($event) {
                                      return _vm.connectorMoveStopped(
                                        $event.el,
                                        $event.finalPos,
                                        connection.sourceBrickId
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("brick-circle", {
                                    staticClass: "composer-component",
                                    attrs: {
                                      "is-active": isActive,
                                      type: connection.destinationBrick.type,
                                      config: connection.config,
                                      x: connection.connectorX,
                                      y: connection.connectorY,
                                      connection: connection,
                                      "is-dragging":
                                        _vm.draggedComponentId === connection.id
                                    },
                                    on: {
                                      "delete-connection-checkpoint": function(
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "delete-connection-checkpoint",
                                          $event
                                        )
                                      },
                                      "change-connection": function($event) {
                                        return _vm.changeConnection(
                                          connection.sourceBrickId,
                                          connection.id,
                                          $event
                                        )
                                      },
                                      "delete-connection": function($event) {
                                        return _vm.deleteConnection(
                                          connection.sourceBrickId,
                                          connection.destinationBrickId,
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }